module.exports = __webpack_public_path__ + "static/cl-dulce2018-prod-54de9bf77d4a58d3ae1a66b7a706bf26.jpg";